import { render, staticRenderFns } from "./PublicEventRegistration.vue?vue&type=template&id=c4c7bbb2&scoped=true"
import script from "./PublicEventRegistration.vue?vue&type=script&lang=js"
export * from "./PublicEventRegistration.vue?vue&type=script&lang=js"
import style0 from "./PublicEventRegistration.vue?vue&type=style&index=0&id=c4c7bbb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c7bbb2",
  null
  
)

export default component.exports